/**
 * Tipos de campanha do Mercado Livre — rótulo ÚNICO para todo o módulo.
 *
 * F27: até aqui a mesma campanha tinha nomes diferentes em três telas
 * ("Campanha do Marketplace", "Lightning Deal", "Co-participacao" com
 * acentuação corrompida) e nenhum era o nome que aparece no painel do próprio
 * Mercado Livre. Os rótulos abaixo seguem a documentação oficial
 * (developers.mercadolivre.com.br/pt_br/gerenciar-ofertas, tabela de
 * características das promoções).
 *
 * F18: `PRICE_MATCHING_MELI_ALL` é a variante 100% custeada pelo Mercado Livre
 * que a doc cita de passagem e que não existia em nenhum mapa do sistema.
 *
 * A ORDEM é a da tabela da documentação, para os seletores de filtro não
 * embaralharem entre telas.
 */
export const CAMPAIGN_TYPE_LABELS = Object.freeze({
    DEAL: 'Campanha tradicional',
    MARKETPLACE_CAMPAIGN: 'Campanha com co-participação',
    PRICE_DISCOUNT: 'Desconto individual',
    VOLUME: 'Desconto por quantidade',
    DOD: 'Oferta do dia',
    LIGHTNING: 'Oferta relâmpago',
    PRE_NEGOTIATED: 'Desconto pré-acordado por item',
    SELLER_CAMPAIGN: 'Campanha do vendedor',
    SMART: 'Co-participação automatizada',
    PRICE_MATCHING: 'Preços competitivos',
    PRICE_MATCHING_MELI_ALL: 'Preços competitivos (100% Mercado Livre)',
    UNHEALTHY_STOCK: 'Liquidação de estoque Full',
    SELLER_COUPON_CAMPAIGN: 'Cupons do vendedor',
    BANK: 'Co-participação para Pix',
});

/** Ordem canônica (a da documentação) para seletores e agrupamentos. */
export const CAMPAIGN_TYPE_ORDER = Object.freeze(Object.keys(CAMPAIGN_TYPE_LABELS));

/** Tipo → rótulo. Desconhecido sai CRU: melhor ver o identificador novo do que escondê-lo. */
export function GetCampaignTypeLabel(type, blank = '—') {
    if (!type) {
        return blank;
    }
    return CAMPAIGN_TYPE_LABELS[type] || type;
}
